export default __webpack_public_path__ + "static/media/pedro.fd674f04.jpg";